import gql from 'graphql-tag';

export const GET_ORGANIZATIONS = gql`
  query getOrganizations($id: ID) {
    getOrganizations(id: $id) {
      id
      name
      governorOrganizationId
      image
      jsonData {
        fileName
      }
    }
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation deleteOrganization($id: ID!) {
    deleteOrganization(id: $id)
  }
`;

export const ADD_OR_UPDATE_ORGANIZATION = gql`
  mutation addOrUpdateOrganization($organization: OrganizationInput) {
    addOrUpdateOrganization(organization: $organization) {
      name
    }
  }
`;

export const GET_ENTITIES = gql`
  query getEntities($id: ID) {
    getEntities(id: $id) {
      id
      entityTypeId
      active
      organizationId
      governorEntityId
      name
      image
      jsonData {
        fileName
      }
    }
  }
`;

export const GET_ENTITY_TYPES = gql`
  query getEntityTypes($id: ID) {
    getEntityTypes(id: $id) {
      id
      organizationId
      operative
      name
      image
      jsonData {
        fileName
      }
    }
  }
`;

export const ADD_OR_UPDATE_CLUB = gql`
  mutation addOrUpdateEntity($entity: EntityInput) {
    addOrUpdateEntity(entity: $entity) {
      name
    }
  }
`;

export const ADD_OR_UPDATE_ENTITY_TYPES = gql`
  mutation addOrUpdateEntityType($entityType: EntityTypeInput) {
    addOrUpdateEntityType(entityType: $entityType) {
      name
    }
  }
`;

export const DELETE_ENTITY = gql`
  mutation deleteEntity($id: ID!) {
    deleteEntity(id: $id)
  }
`;

export const DELETE_ENTITY_TYPE = gql`
  mutation deleteEntityType($id: ID!) {
    deleteEntityType(id: $id)
  }
`;
